import {
  BenefitItem,
  PauseDurationOption,
  PillSelectorOption,
} from "../types/unsubscribe";

export const PAUSE_DURATION_OPTIONS: PauseDurationOption[] = [
  {
    value: "3_months",
    label: "Unsubscribe for 3 months",
    description:
      "Off the job market? We'll pause the updates & reconnect in 3 months.",
    eventName: "All emails3M",
  },
  {
    value: "6_months",
    label: "Unsubscribe for 6 months",
    description:
      "Updates will pause. We'll reconnect after your 6-month break.",
    eventName: "All emails6M",
  },
  {
    value: "permanent",
    label: "Unsubscribe permanently",
    description:
      "It's easy to miss the right job — how about a short pause instead?",
    eventName: "All email permanently",
  },
];

// Format for PillSelector component
export const getPillSelectorOptions = (
  selectedDuration: string,
): PillSelectorOption[] => {
  return PAUSE_DURATION_OPTIONS.map((option) => ({
    id: option.value,
    selected: selectedDuration === option.value,
    text: option.label,
    name: option.value,
  }));
};

export const PAUSE_BENEFITS: BenefitItem[] = [
  {
    id: "auto_notifications",
    text: "Automatically get job notifications again when you are back in the job market",
  },
  {
    id: "recruiter_reach",
    text: "Let recruiters reach out to you with relevant roles",
  },
  {
    id: "unexpected_opportunities",
    text: "Stay open to faster, unexpected opportunities to switch jobs",
  },
];

export const getSingleRecruiterDescription = (
  recruiterName?: string,
): string => {
  return `Prefer to pause updates? Unsubscribe from ${recruiterName || "this recruiter"} for 3 months.`;
};

export const getPauseDurationDescription = (duration: string): string => {
  const option = PAUSE_DURATION_OPTIONS.find((opt) => opt.value === duration);
  return option?.description || "";
};

export const shouldShowBenefits = (duration: string): boolean => {
  return duration === "permanent";
};

export const shouldShowWarning = (duration: string): boolean => {
  return duration === "permanent";
};

export const getConfirmButtonModifier = (
  duration: string,
): "primary" | "register" => {
  return duration === "permanent" ? "register" : "primary";
};
